import {formatCurrency, useDateTimeFormatter, useLocale} from 'platform/locale';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';

import type {GridPdfExportCallback} from 'features/eag-grid';

import {createReceiveNotePdfData} from '../utils/createReceiveNotePdfData';

const PDF_FILENAME = 'receive-notes.pdf';
const BRAND = 'OMNETIC';

export function useReceiveNotePdfExport(): GridPdfExportCallback {
  const formatDateTime = useDateTimeFormatter();
  const {localeConfig} = useLocale();

  return async (context, signal) => {
    signal.throwIfAborted();
    const records = createReceiveNotePdfData(context, {
      currency: (amount, currency) => {
        const number = formatCurrency(localeConfig, amount, 2);
        return isNil(number) ? null : `${number} ${currency}`;
      },
      yes: i18n.t('general.labels.yes'),
      no: i18n.t('general.labels.no'),
    });
    const selection = i18n.t('page.datagrid.labels.numberOfSelectedRows', {
      selectedRows: records.length,
    });
    const exportedAt = formatDateTime('dateTimeShort', context.exportedAt);
    const {createReceiveNotePdf} = await import('../utils/createReceiveNotePdf');
    signal.throwIfAborted();
    const bytes = await createReceiveNotePdf(
      {
        title: i18n.t('page.warehouse.labels.receiveNotes'),
        brand: BRAND,
        metadata: `${selection} | ${i18n.t('general.actions.export')} ${exportedAt}`,
        records,
      },
      signal
    );
    return {bytes, filename: PDF_FILENAME};
  };
}
